import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import logoImage from "../assets/logo.png"; // adjust as needed
import "../styles/style.css";
import { supabase } from "../services/supabaseClient";

const Register = () => {
  const SERVER_URL = `http${process.env.REACT_APP_API_URL}`;

  const [username, setUsername] = useState("");
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [role, setRole] = useState("");
  const navigate = useNavigate();
  const [verifyStage, setVerifyStage] = useState(false);
  const [verificationToken, setVerificationToken] = useState("");

  const handleRegister = async (e) => {
    e.preventDefault();
    const { data, error } = await supabase.auth.signUp({
      email,
      password,
    });

    if (error) {
      alert(error.message);
      return;
    }

    // Add an input box to accept verificaiton token
    setVerifyStage(true);
  };

  const handleVerify = async (e) => {
    e.preventDefault();
    const { data, error } = await supabase.auth.verifyOtp({
      email,
      token: verificationToken,
      type: "email",
    });


    if (error) {
      alert(error.message);
      return;
    }

    console.log("Verification successful, data: ", data);
    console.log("User data: ", JSON.stringify({
      username,
      email,
      full_name: fullName,
      role,
      subscription_tier: 'free',
      sub: data.user.id,
    }));

    const response = await fetch(`${SERVER_URL}/register`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${data.session.access_token}`,
      },
      body: JSON.stringify({
        username,
        email,
        full_name: fullName,
        role,
        subscription_tier: 'free',
        sub: data.user.id,
      }),
    });

    if (response.ok) {
      alert("Registration successful. Please log in.");
      navigate("/login");
    } else {
      alert("Registration failed.");
    }
  };

  return (
    <div className="registration-container">
      <img src={logoImage} alt="Guardian Logo" className="login-logo-image" />
      <h1 className="login-logo-text">GUARDIAN SPHERE</h1>
      {!verifyStage && (<div className="login-card" style={{ marginTop: "24px" }}>
        <h2 className="login-title">Create Your Account</h2>
        <form onSubmit={handleRegister} className="login-form">
          <input
            type="text"
            placeholder="Full Name"
            value={fullName}
            onChange={(e) => setFullName(e.target.value)}
            required
          />
          <input
            type="text"
            placeholder="Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$"
            required
          />
          <select
            value={role}
            onChange={(e) => setRole(e.target.value)}
            required
          >
            <option value="">Select Role</option>
            <option value="guardian">Guardian</option>
            <option value="ward">Ward</option>
          </select>
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <button type="submit">Register</button>
        </form>
        <p style={{ marginTop: "1rem", color: "#aaa" }}>
          Already have an account? <a href="/login" style={{ color: "white" }}>Log in</a>
        </p>
      </div>)}
      {verifyStage && (
        <div className="login-card">
          <h2 className="login-title">Verify Your Account</h2>
          <form onSubmit={handleVerify} className="login-form">
            <input
              type="text"
              placeholder="Verification Token"
              value={verificationToken}
              onChange={(e) => setVerificationToken(e.target.value)}
              required
            />
            <button type="submit">Verify</button>
          </form>
        </div>
      )}

    </div>
  );
};

export default Register;
